<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'antiguedad'"
      [camposVisibles]="['selectFilter']"
      (filterChange)="onFilterChange($event)"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>

  @if (insuranceData.length > 0) {
  <p class="company-title">Navegación por empresas</p>

  <div class="navigation-controls">
    <ul class="custom-pagination">
      <li class="custom-page-item">
        <a
          class="nav-button"
          [class.disabled]="currentCompanyIndex === 0"
          (click)="previousCompany()"
        >
          <span class="material-symbols-outlined" style="color: #004379"
            >chevron_left</span
          >
        </a>
      </li>

      <li class="custom-page-item" [class.active]="currentCompanyIndex === 0">
        <a class="custom-page-link" (click)="goToCompany(0)">1</a>
      </li>

      @if (insuranceData.length > 1) {
      <li class="custom-page-item" [class.active]="currentCompanyIndex === 1">
        <a class="custom-page-link" (click)="goToCompany(1)">2</a>
      </li>
      } @if (insuranceData.length > 2) {
      <li class="custom-page-item" [class.active]="currentCompanyIndex === 2">
        <a class="custom-page-link" (click)="goToCompany(2)">3</a>
      </li>
      } @if (insuranceData.length > 3) { @if (currentCompanyIndex > 2 &&
      currentCompanyIndex < insuranceData.length - 1) {
      <li class="custom-page-item active">
        <a class="custom-page-link">{{ currentCompanyIndex + 1 }}</a>
      </li>
      }

      <li class="custom-page-item">
        <a
          class="custom-page-link"
          (click)="goToCompany(insuranceData.length - 1)"
          >{{ insuranceData.length }}</a
        >
      </li>
      }

      <li class="custom-page-item">
        <div class="page-input">
          <input
            type="text"
            [(ngModel)]="inputCompanyPage"
            size="1"
            (keypress)="onKeyPress($event)"
          />
        </div>
      </li>

      <li class="custom-page-item">
        <button
          class="custom-page-link"
          (click)="goToCompany(inputCompanyPage - 1)"
        >
          Ir
        </button>
      </li>

      <li class="custom-page-item">
        <a
          class="nav-button"
          [class.disabled]="currentCompanyIndex === insuranceData.length - 1"
          (click)="nextCompany()"
        >
          <span class="material-symbols-outlined" style="color: #004379"
            >chevron_right</span
          >
        </a>
      </li>
    </ul>
  </div>
  }
</div>
@if(errorStatus === 404) {
<div class="card antiguedad-card mt-2">
  <div class="antiguedad-no-data">No hay datos disponibles para mostrar</div>
</div>
} @for (group of getCompaniesToShow(); track group.debtorId) {
<div class="table-section">
  <div class="client-name">{{ group.debtorName }}</div>
  <app-insurance-table
    [data]="group.agingProducers"
    [config]="tableConfig"
    [isAging]="true"
    [mensajeNoData]="mensajeNoData"
    [error]="errorStatus"
    [itemsPerPage]="4"
  ></app-insurance-table>
</div>
}
